import { render, staticRenderFns } from "./PayrollEditPanel.vue?vue&type=template&id=a6097b7a&scoped=true&"
import script from "./PayrollEditPanel.vue?vue&type=script&lang=js&"
export * from "./PayrollEditPanel.vue?vue&type=script&lang=js&"
import style0 from "./PayrollEditPanel.vue?vue&type=style&index=0&id=a6097b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6097b7a",
  null
  
)

export default component.exports